import { Badge } from '@new/common/ui/Badge/Badge';

export interface ButtonInputsOption<T extends string> {
  label: string;
  value: T;
}

interface ButtonInputsProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: ButtonInputsOption<T>[];
  wrap?: boolean;
  size?: 'sm' | 'input';
  className?: string;
}

export function ButtonInputs<T extends string>({
  value,
  onChange,
  options,
  wrap = false,
  size = 'sm',
  className = '',
}: ButtonInputsProps<T>) {
  const isInput = size === 'input';

  return (
    <div
      className={`flex items-center gap-2 ${wrap ? 'flex-wrap' : ''} ${isInput ? 'w-full' : ''} ${className}`}
    >
      {options.map((option) => (
        <button
          key={option.value || 'all'}
          type="button"
          aria-pressed={value === option.value}
          onClick={() => onChange(option.value)}
          className={`cursor-pointer ${isInput ? 'flex-1' : ''}`}
        >
          <Badge
            variant={value === option.value ? 'orange-solid' : 'white'}
            className={
              isInput
                ? 'flex h-10 w-full items-center justify-center rounded-md! text-sm'
                : 'px-3 py-1.5 text-sm'
            }
          >
            {option.label}
          </Badge>
        </button>
      ))}
    </div>
  );
}
